"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewSF = void 0;
function viewSF() {
    var _this = this;
    return {
        constructor: function (props) {
            _this.state = {
                isVisible: _this.props.imageUrl.length > 0
            };
        },
        mounted: function () {
        },
        events: {}
    };
}
exports.viewSF = viewSF;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/PSQImage/ViewSF.js
// module id = 640
// module chunks = 0